import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { Button } from '@material-ui/core/';
import React from 'react';

import { IDealTPAccount } from '~/src/dash/api/deals';
import { IStore } from '~/src/dash/reducers/store';
import { IReduxActionProps, ISessionStateProps, IUserStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { toTitleCase } from '~/src/dash/utils/text-tools';

interface IProps extends IReduxActionProps, ISessionStateProps, IUserStateProps {
  tpAccounts: IDealTPAccount[];
  onChange: (d: IDealTPAccount[]) => void;
}

interface IState {}

export const DealTPAccountList = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = {};
    }

    // Handle the change of one field in a given account.
    handleAccountChange(
      account: IDealTPAccount,
      field: 'Username' | 'Password' | 'ThirdPartyUserID',
      newValue: string,
    ) {
      account[field] = newValue;
      this.props.onChange(this.props.tpAccounts);
    }

    render() {
      // Get variable from the props.
      const { tpAccounts } = this.props;

      return (
        <TableContainer>
          <Table style={{ padding: '10px' }}>
            {/* Declaration of table heads. */}
            <TableHead>
              <TableRow>
                <TableCell>Partner</TableCell>
                <TableCell>Username/Email</TableCell>
                <TableCell>Password</TableCell>
                <TableCell>Account ID</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>

            {/* Declaration of table's body. */}
            <TableBody>
              {
                // For each third-party account, we display one row.
                tpAccounts.map((account: IDealTPAccount) => (
                  <TableRow>
                    {/* Partner*/}
                    <TableCell style={{ fontSize: '16px' }}>
                      {toTitleCase(account.APIName === 'rhythmone' ? 'unruly' : account.APIName)}
                    </TableCell>

                    {/* Username */}
                    <TableCell>
                      <TextField
                        label={'Username'}
                        value={account.Username}
                        size={'small'}
                        fullWidth={true}
                        onChange={(e) =>
                          this.handleAccountChange(account, 'Username', e.target.value)
                        }
                      />
                    </TableCell>

                    {/* Password */}
                    <TableCell>
                      <TextField
                        label={'Password'}
                        value={account.Password}
                        size={'small'}
                        fullWidth={true}
                        onChange={(e) =>
                          this.handleAccountChange(account, 'Password', e.target.value)
                        }
                        type={'password'}
                      />
                    </TableCell>

                    {/* Third Party User ID/Account ID */}
                    <TableCell>
                      <TextField
                        label={'Account ID'}
                        value={account.ThirdPartyUserID}
                        size={'small'}
                        fullWidth={true}
                        onChange={(e) =>
                          this.handleAccountChange(account, 'ThirdPartyUserID', e.target.value)
                        }
                      />
                    </TableCell>

                    {/* Delete button (not available yet, but we use a tooltip to inform the user) */}
                    <TableCell>
                      <Tooltip title={'Deleting an account will be available soon.'}>
                        <div>
                          <Button disabled>Delete</Button>
                        </div>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  },
);
